<template>
  <div class="antialiased">
    <Sidebar/>

    <div class="page">
      <Header hint="Ketik nama perusahaan"/>
      <div class="content">
        <div class="container">
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">
                  Faktur Pajak Searcher
                </h2>
              </div>
            </div>
          </div>
          <!-- <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
          <Nodata v-if="!loading && perusahaans.data.length == 0"/>
           -->
            <div class="box">
              <div class="card">
                <div class="table-responsive" style="padding : 20px; overflow : auto; max-height : 630px">
                  <div>
                    <div style="margin-bottom : 10px">
                      <button class="btn btn-primary" style="opacity : 0.8" @click="$refs.file.click()"> <i class="fa fa-chevron-up" aria-hidden="true"></i> <span style="margin-left : 10px">Upload</span> </button>
                      <button class="btn btn-primary" style="opacity : 0.8" @click="_downloadExcel()"> <i class="fa fa-chevron-down" aria-hidden="true"></i> <span style="margin-left : 10px">Download</span> </button>
                      <button @click="_proses" class="btn btn-primary"> <i class="fa fa-search" aria-hidden="true"></i> <span style="margin-left : 10px">Proses</span></button>
                    </div>
                    <input type="file" hidden class="form-input" accept=".xlsx,.xls" ref="file" @change="_onFile">
                    <input type="text" v-model="newColumn"  class="form-control"  v-on:keyup="addNewColumn" placeholder="Input New Column">
                  </div>
                  <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loadingImport"/>
                  <table class="table" v-if="cop.length > 1 && !loadingImport">
                    <tr>
                      <td width="50"><button :disabled="data.length != 0" class="btn btn-sm btn-outline-secondary" v-html="ic('plus')" @click="addNewRow" style="height : 35px"></button></td>
                      <td width="50"><button disabled class="btn btn-sm btn-outline-secondary" v-html="ic('minus')" style="height : 35px"></button></td>
                      <td v-for="(row,i) in cop" :key="i"><button class="btn btn-sm form-control" @click="parameterUrl=i" :class="i==parameterUrl ? 'btn-outline-primary' : 'btn-outline-secondary'">{{row}}</button></td>
                    </tr>
                    <tr v-for="(row,i) in data" :key="i">
                      <td width="50"><button :disabled="i != data.length-1" class="btn btn-sm btn-outline-secondary" v-html="ic('plus')" @click="addNewRow"></button></td>
                      <td width="50"><button class="btn btn-sm btn-outline-secondary" @click="data.splice(i, 1)" v-html="ic('minus')"></button></td>
                      <td v-for="(sub,j) in cop" :key="j">
                        <input type="text" v-model="data[i][j]" class="form-control">
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading"/>
            <div class="box" v-if="dataRequest.length > 0 && !loading">
              <div class="card">
                <div style="padding : 20px">
                  <div class="row">
                    <div class="col-6">
                      <h2 class="page-title">Data Founded</h2>
                    </div>
                    <div class="col-6" style="text-align : right">
                        <button class="btn btn-primary" @click="_downloadExcelFounded()"> <i class="fa fa-file-o" aria-hidden="true"></i> <span style="margin-left : 10px">Download</span> </button>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="table no-break">
                      <tr>
                        <template v-for="(cop, j) in dataRequest[0]">
                          <td v-if="j != 'detailTransaksi'" :key="j">{{j}}</td>
                        </template>
                        <template v-if="dataRequest[0].detailTransaksi.length>0">
                          <td v-for="(detail,k) in dataRequest[0].detailTransaksi[0]"  :key="'cop_detail'+k">{{k}}</td>
                        </template>
                        <template v-else>
                          <td v-for="(detail,k) in dataRequest[0].detailTransaksi"  :key="'cop_detail'+k">{{k}}</td>
                        </template>
                      </tr>
                      <template v-for="(row, i) in dataRequest">
                        <template v-if="row.detailTransaksi.length>0">
                          <tr v-for="(sub, l) in row.detailTransaksi" :key="'sub'+i+l">
                            <template v-for="(cop, j) in row">
                              <td v-if="j != 'detailTransaksi'" :key="'detail'+j">{{row[j]}}</td>
                            </template>
                            <td>{{sub.nama}}</td>
                            <td>{{sub.hargaSatuan}}</td>
                            <td>{{sub.jumlahBarang}}</td>
                            <td>{{sub.hargaTotal}}</td>
                            <td>{{sub.diskon}}</td>
                            <td>{{sub.dpp}}</td>
                            <td>{{sub.ppn}}</td>
                            <td>{{sub.tarifPpnbm}}</td>
                            <td>{{sub.ppnbm}}</td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <template v-for="(cop, j) in row">
                              <td v-if="j != 'detailTransaksi'" :key="'detail'+j">{{row[j]}}</td>
                            </template>
                            <td>{{row.detailTransaksi.nama}}</td>
                            <td>{{row.detailTransaksi.hargaSatuan}}</td>
                            <td>{{row.detailTransaksi.jumlahBarang}}</td>
                            <td>{{row.detailTransaksi.hargaTotal}}</td>
                            <td>{{row.detailTransaksi.diskon}}</td>
                            <td>{{row.detailTransaksi.dpp}}</td>
                            <td>{{row.detailTransaksi.ppn}}</td>
                            <td>{{row.detailTransaksi.tarifPpnbm}}</td>
                            <td>{{row.detailTransaksi.ppnbm}}</td>
                          </tr>
                        </template>
                      </template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
export default {
  name: "faktur-pajak-search.vue",
  mixins: [helper],
  data() {
    return {
      loading : false,
      loadingImport : false,
      parameterUrl : 0,
      files : null,
      keyword: '',
      newColumn : '',
      cop : ['no'],
      data : [],
      dataRequest : [],
    }
  },
  computed: {
  },
  methods: {
    addNewColumn(e){
      if (e.keyCode === 13) {
        this.cop.push(this.newColumn)
        this.newColumn = ''
      } 
    },
    addNewRow(){
      this.data.push({})
    },
    _onFile(e, params){
      this.loadingImport = true
      const files = params == null ? e.target.files : params.files;
      let formData = new FormData();
      formData.append('file', files[0]);
      console.log(files)
      this.axios.post('testing/excel/converter', formData).then(res => {
        this.parameterUrl = res.data.parameterUrl
        this.cop = res.data.cop
        this.data = this.data.concat(res.data.data)
        this.loadingImport = false
      }).catch(err => {
        this.onError(err);
        this.loadingImport = false
      })
    },
    _proses(){
      this.loading = true
      this.axios.post('testing/faktur_pajak/search',{
          cop : this.cop,
          data : this.data,
          parameterUrl : this.parameterUrl
      }).then(res => {
        this.loading = false
        this.dataRequest = res.data
      }).catch(err => {
        this.loading = false
        this.onError(err);
      })
    },
    _downloadExcel(){
      let data = {...this.data}
      let dataExcel = []
      for (let i in data) {
        let row = data[i]
        let res = {};
        for (let j = 0; j < row.length; j++) {
          res[this.cop[j]] = row[j]
        }
        dataExcel.push(res)
      }
        this.createExcel({data: dataExcel, filename: 'Data Pencarian Faktur Pajak'})
    },
    _downloadExcelFounded(){
      let data = this.dataRequest
      let dataExcel = [];
      for (let i = 0; i < data.length; i++) {
        let sub = data[i]
        if(sub.detailTransaksi.length > 0){
          for (let l = 0; l < sub.detailTransaksi.length; l++) {
            let res = {}
            let detail = sub.detailTransaksi[l]
            for (let item in sub) {
              if(item != 'detailTransaksi'){
                res[item] = sub[item]
              }
            }
            res = {...res,...detail};
            dataExcel.push(res)
          }
        }
        else{
          let res = {}
          for (let item in sub) {
            if(item != 'detailTransaksi'){
              res[item] = sub[item]
            }
          }
          let detail = sub.detailTransaksi
          res = {...res,...detail};
          dataExcel.push(res)
        }
      }
      this.createExcel({data: dataExcel, filename: 'Data Hasil Pencarian Faktur Pajak'})
    },
  },
}
</script>

<style scoped>
  .v-center {
    vertical-align: middle;
  }
  .btn-primary {
    margin-right: 10px;
  }
</style>
